export const cartLine = `
id
quantity
attributes {
  key
  value
}
cost {
  totalAmount {
    amount
    currencyCode
  }
  subtotalAmount {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    quantityAvailable
    id
    sku
    selectedOptions {
      name
      value
    }
    image {
      altText
      url(transform: { preferredContentType: WEBP })
      width
      height
    }
    price {
      amount
      currencyCode
    }
    compareAtPrice {
      amount
      currencyCode
    }
    availableForSale
    product {
      ... on Product {
        id
        title
        handle
        tags
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  totalAmount {
    amount
    currencyCode
  }
  subtotalAmount {
    amount
    currencyCode
  }
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const variant = `
quantityAvailable
availableForSale
id
sku
price {
  amount
  currencyCode
}
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
image {
  altText
  url(transform: { preferredContentType: WEBP })
  width
  height
}
product {
  ... on Product {
    title
    id
    handle
    options {
      id
      values
      name
    }
    tags
  }
}
`;

export const metaFields = `
badge_text: metafield(namespace: "badge", key: "text") {
  value
}
urgency_message: metafield(namespace: "custom", key: "urgency_message") {
  value
}
badge_color: metafield(namespace: "badge", key: "color") {
  value
}
badge_image: metafield(namespace: "badge", key: "image") {
  value
}
model_callout: metafield(namespace: "custom", key: "model_callout") {
  value
}
thumbnail_override_1: metafield(namespace: "thumbnail", key: "override_1") {
  value
}
thumbnail_override_2: metafield(namespace: "thumbnail", key: "override_2") {
  value
}
product_tabs: metafield(namespace: "custom", key: "tabs") {
  value
}
product_option_tabs: metafield(namespace: "custom", key: "option_tabs") {
  value
}
product_option_tabs_title: metafield(namespace: "custom", key: "options_tabs_title") {
  value
}
product_breadcrumbs: metafield(namespace: "custom", key: "breadcrumbs") {
  value
}
related_products: metafield(namespace: "custom", key: "related_product_links") {
  value
}
preorder_shipping: metafield(namespace: "preorder", key: "preorder_shipping") {
  value
}
size_guide_handle: metafield(namespace: "custom", key: "size_guide_handle") {
  value
}
size_callout: metafield(namespace: "custom", key: "size_callout") {
  value
}
urgency_messaging: metafield(namespace: "custom", key: "product_urgency_messaging") {
  value
}
product_subtitle: metafield(namespace: "product", key: "subtitle") {
  value
}
product_subtitle_color: metafield(namespace: "product", key: "subtitle_color") {
  value
}
highlights_subtitle: metafield(namespace: "product", key: "highlights") {
  value
}
highlights_color: metafield(namespace: "product", key: "highlights_hex_color") {
  value
}
show_final_sale: metafield(namespace: "product", key: "show_final_sale") {
  value
}
gwp_promotion: metafield(namespace: "custom", key: "gwp_promotion") {
  value
}
`;

export const product = `
title
availableForSale
productType
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
  maxVariantPrice {
    amount
    currencyCode
  }
}
handle
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
  maxVariantPrice {
    amount
    currencyCode
  }
}
${metaFields}
id
tags
options {
  id
  values
  name
}
featuredImage {
  altText
  url(transform: { preferredContentType: WEBP })
  width
  height
}
images(first: 2) {
  edges {
    node {
      altText
      height
      width
      url(transform: { preferredContentType: WEBP })
    }
  }
}
media(first: 10) {
  edges {
    node {
      mediaContentType
      ... on ExternalVideo {
        alt
        embedUrl
        id
        host
        previewImage {
          altText
          height
          width
          url(transform: { preferredContentType: WEBP })
        }
      }
      ... on Video {
        id
        alt
        previewImage {
          altText
          height
          width
          url(transform: { preferredContentType: WEBP })
        }
        sources {
          format
          url
          height
          width
        }
      }
      ... on MediaImage {
        id
        alt
        image{
          altText
          height
          width
          url(transform: { preferredContentType: WEBP })
        }
      }
    }
  }
}
`;

export const productWithVariants = `
${product}
variants(first: 100) {
  edges {
    node {
      ${variant}
    }
  }
}
`;
